<template>
  <el-container class="admin-layout">
    <el-aside :width="sidebarWidth" class="admin-sidebar">
      <Sidebar />
    </el-aside>
    <el-container>
      <el-header class="admin-header">
        <Navbar />
      </el-header>
      <div class="admin-tags">
        <TagsView />
      </div>
      <el-main class="admin-main">
        <keep-alive :include="cachedViews">
          <router-view />
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Navbar from './Navbar.vue'
import Sidebar from './Sidebar.vue'
import TagsView from './TagsView.vue'
import { mapState } from 'vuex'

export default {
  name: 'AdminLayout',
  components: {
    Navbar,
    Sidebar,
    TagsView
  },
  computed: {
    ...mapState('app', ['sidebarCollapsed']),
    cachedViews() {
      return this.$store.getters['tagsView/cachedViews']
    },
    sidebarWidth() {
      return this.sidebarCollapsed ? '64px' : '220px'
    }
  },
  async created() {
    // 进入管理端布局时，保证用户信息和权限已加载
    try {
      if (!this.$store.state.user.userInfo) {
        await this.$store.dispatch('user/getInfo')
      }
      await this.$store.dispatch('user/loadPermissions')
    } catch (e) {
      // 加载失败时走登出流程避免死循环
      console.warn('[AdminLayout] 加载用户权限失败:', e && e.message)
    }
  }
}
</script>

<style scoped>
.admin-layout {
  height: 100%;
}

.admin-sidebar {
  background-color: #304156;
  transition: width 0.3s;
  overflow: hidden;
}

.admin-header {
  background: #fff;
  padding: 0;
  border-bottom: 1px solid #e6e6e6;
  height: 50px !important;
  line-height: 50px;
}

.admin-main {
  background-color: #f0f2f5;
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
</style>